import { render } from "./sucursalView.vue?vue&type=template&id=3e70d7aa"
import script from "./sucursalView.vue?vue&type=script&lang=js"
export * from "./sucursalView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__